// validationUtils.ts
export const removeEmoji = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, "");
};

export const validateEmailFormat = (email: string): boolean => {
  email = email.trim();
  if (email === "") return true;
  
  const emailPattern = /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,6}$/;
  return emailPattern.test(email) && 
         !email.includes("..") && 
         !email.startsWith(".") && 
         !email.endsWith(".") && 
         !email.includes(".@") && 
         !email.includes("@.");
};

export const sanitizeName = (val: string): string => {
  let value = removeEmoji(val);
  return value.replace(/[^a-zA-Z0-9\u0600-\u06FF'\-_\s()]/g, "").slice(0, 25);
};

export const sanitizePhone = (val: string): string => {
  let value = removeEmoji(val).replace(/[^0-9+\s()]/g, "");
  const digits = value.replace(/\D/g, "");
  return digits.length > 8 ? digits.slice(0, 8) : value;
};

export const sanitizePincode = (val: string): string => {
  let value = removeEmoji(val).replace(/[^0-9\s]/g, "").replace(/\s+/g, " ");
  const digits = value.replace(/\s/g, "");
  return digits.length > 10 ? digits.slice(0, 10) : value;
};

export const hasDigits = (phone: string, minDigits: number = 8): boolean => {
  return phone.replace(/\D/g, "").length >= minDigits;
};

export const isDuplicatePhone = (phone1: string, phone2: string): boolean => {
  const digits1 = phone1.replace(/\D/g, "");
  const digits2 = phone2.replace(/\D/g, "");
  return digits1 === digits2 && digits1 !== "";
};